// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__rIlLl","pointer":"Icon_pointer__trLF1","disabled":"Icon_disabled__AwdM6"};